export default "__VITE_ASSET__B1Epc6Iz__"